// React
import React, { useState } from 'react';
import { Alert, Card, Col, Row, Spinner } from 'reactstrap';

// Containeirs Injections & Components
import { SearchGroup } from '../../components/searchGroup';
import { SelectTable } from '../../components/selectTable';
import ChangeOrganization from '../../components/changeOrganization';
import { ModalEditValueOfPlan } from '../../components/modalEditValue';
import {
  PageWrapper,
  FloatButtonProposal,
} from '../../containers/componentsInjection';

export const ViewChangeMonthlyPaymentList = ({
  reset,
  toggle,
  isOpen,
  loading,
  columns,
  proposals,
  handleEdit,
  totalPrice,
  validation,
  selectedRows,
  planSelected,
  handleSearch,
  handleSubmitOrg,
  isModalChangeOrg,
  toggleModalChangeOrg,
  categoryPlanSelected,
  handleSubmitEditValue,
  handleChangeSelectedRows,
}) => {
  const [showButton, setShowButton] = useState();

  const verifyIfExistProposals = () => {
    return (proposals || []).length > 0;
  };

  const verifyIfExistOrganization = () => {
    if (validation.values.organization) {
      return true;
    }
  };

  const formattedTotalPrice = totalPrice.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return (
    <PageWrapper title={'Alterar Propostas em Lote'}>
      <Row>
        <Col xs={12}>
          <Card>
            <div id="table-gridjs">
              <SearchGroup
                handleSearch={handleSearch}
                validation={validation}
                reset={reset}
              />

              {verifyIfExistProposals() && (
                <>
                  {selectedRows.length > 0 && (
                    <div data-aos="fade-down" data-aos-duration="1000">
                      <Alert color="primary" className="border-0 border-0">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>
                              {selectedRows.length}{' '}
                              {selectedRows.length === 1
                                ? 'registro'
                                : 'registros'}{' '}
                              selecionado(s)
                            </strong>
                          </div>

                          <div>
                            <span className="fw-bold">Total:</span>{' '}
                            <span className="fw-medium">
                              {formattedTotalPrice}
                            </span>
                          </div>
                        </div>
                      </Alert>
                    </div>
                  )}
                  <SelectTable
                    progressPending={loading}
                    selectableRows
                    onSelectedRowsChange={handleChangeSelectedRows}
                    progressComponent={
                      <Spinner
                        type="grow"
                        style={{
                          margin: 25,
                        }}
                      />
                    }
                    columns={columns}
                    loading={loading}
                    data={proposals || []}
                    persistTableHead
                    actions={[
                      {
                        id: 1,
                        name: 'edit',
                        label: 'Editar',
                        onPress: (cellProps) => handleEdit(cellProps),
                        icon: 'la-pen',
                        classNameColorIcon: 'primary',
                      },
                    ]}
                  />
                </>
              )}
            </div>
          </Card>
        </Col>
      </Row>

      {verifyIfExistProposals() && (
        <FloatButtonProposal
          validation={validation}
          showButton={showButton}
          verifyIfExistOrganization={verifyIfExistOrganization}
          handleButton={() => setShowButton((prev) => !prev)}
          icon={'ri-add-fill'}
          toggle={toggle}
          toggleModalChangeOrg={toggleModalChangeOrg}
        />
      )}

      <ModalEditValueOfPlan
        handleSubmit={handleSubmitEditValue}
        selectedRows={selectedRows}
        toggle={toggle}
        isOpen={isOpen}
        planSelected={planSelected}
        categoryPlanSelected={categoryPlanSelected}
      />

      <ChangeOrganization
        handleSubmitOrg={handleSubmitOrg}
        isModalChangeOrg={isModalChangeOrg}
        toggleModalChangeOrg={toggleModalChangeOrg}
      />
    </PageWrapper>
  );
};
